declare const skyway_room: any;

import * as React  from "react";
import { useState, useRef, useEffect } from 'react';
import axios from 'axios';
import { createConsumer } from '@rails/actioncable';


let timer;

const { 
  SkyWayContext,
  SkyWayRoom,
  SkyWayStreamFactory,
} = skyway_room;

// skyway
const newCall = (props) => {
  const localVideo = useRef<HTMLVideoElement>(null);
  const remoteMediaArea = useRef(null);
  const stopButton = useRef(null);
  const reloadButton = useRef(null);

  const [isSpeaking, setIsSpeaking] = useState<boolean>(false);
  const [isEndCall, setIsEndCall] = useState<boolean>(false);
  const [time, setTime] = useState<number>(0);
  const [channelId, setChannelId] = useState<string>("");

  const [captureErrorMessage, setCaptureErrorMessage] = useState<string>("");
  const [successCaptureCount, setSuccessCaptureCount] = useState<number>(0);
  const [videoEnableCheckMessages, setVideoEnableCheckMessages] = useState([]);
  const [recordSessionId, setRecordSessionId] = useState<string>("");
  // イベントハンドラ用
  const recordSessionIdRef = useRef<string>("");
  const [showRecordButton, setShowRecordButton] = useState<boolean>(true);
  const [recordingNotification, setRecordingNotification] = useState<string>("");
  const [recordingTime, setRecordingTime] = useState<number>(0);
  // ファイル上部のstate定義部分で
  const [recordingTimer, setRecordingTimer] = useState<NodeJS.Timeout | null>(null);
  const RECORDING_MAX_TIME = 15 * 60; // 15分（秒）
  const [recordingErrorMessage, setRecordingErrorMessage] = useState<string>("");
  const [recordingEnded, setRecordingEnded] = useState<boolean>(false);


  const displayCaptureImages: React.MutableRefObject<any> = useRef(null);
  const captureImage: React.MutableRefObject<any> = useRef(null);

  // メディアストリームとリソースを完全に停止する関数
  const stopAllMediaStreams = (audio, video, audioContext) => {
    try {
      // オーディオトラックを停止
      if (audio && audio.track) {
        audio.track.stop();
      }
      
      // ビデオトラックを停止
      if (video && video.track) {
        video.track.stop();
      }
      
      // ローカルビデオ要素のストリームを解放
      if (localVideo.current) {
        localVideo.current.srcObject = null;
      }
      
      // AudioContextを停止
      if (audioContext && audioContext.state !== 'closed') {
        audioContext.close();
      }
      
    } catch (error) {
      console.error('メディアストリーム停止エラー:', error);
    }
  };

  // 画像
  const micIcon = require("../../images/microphone.png")
  const informationImg =  require("../../images/information.png");
  const endCallImg = require("../../images/endcall.png");
  const cameraImg = require("../../images/screenshots.png");
  const thankyouImg = require("../../images/ojigi_nurse_man.png");
  const recordCircleImg = require("../../images/record-circle.svg");


  useEffect(() => {
    (async () => {
      // 初期チェック
      await videoCheck();

      //skywayコンテンツ作成
      const context = await SkyWayContext.Create(props.token, {log: { level: props.log_level, format: 'string' }});

      // ローカル表示
      const { audio, video } = await SkyWayStreamFactory.createMicrophoneAudioAndCameraStream();
      video.attach(localVideo.current);
      await localVideo.current.play();

      // AudioContextを外部スコープで定義
      let audioContext = null;

      // 音声表示
      try{
        const stream = new MediaStream([audio.track]);
        const canvas = document.getElementById("canvas") as HTMLCanvasElement;
        const drawContext = canvas.getContext("2d")
        let WIDTH = canvas.width;
        let HEIGHT = canvas.height;
        audioContext = new AudioContext();
        const sourceNode = audioContext.createMediaStreamSource(stream);
        const analyserNode = audioContext.createAnalyser();
        analyserNode.fftSize = 2048;
        sourceNode.connect(analyserNode);
  
        const draw = () => {
          const barWidth = canvas.width / analyserNode.fftSize;
          const array = new Uint8Array(analyserNode.fftSize);
          analyserNode.getByteTimeDomainData(array);
          drawContext.fillStyle = 'black';
          drawContext.fillRect(0, 0, WIDTH, HEIGHT);
      
          for (let i = 0; i < analyserNode.fftSize; ++i) {
            const value = array[i];
            const percent = value / 255;
            const height = canvas.height * percent;
            const offset = canvas.height - height;
      
            drawContext.fillStyle = 'lime';
            drawContext.fillRect(i * barWidth, offset, barWidth, 2);
          }
      
          requestAnimationFrame(draw);
        }
  
        draw();
      }catch(e){
        console.error('AudioContext() error:', e);
      }finally{
      //ルーム作成
      const room = await SkyWayRoom.FindOrCreate(context, {
        type: 'sfu',
        name: `room_id_${props.room_id}`,
      });

      // 人数確認
      if (room.members.length >= 2) {
        stopAllMediaStreams(audio, video, audioContext);
        window.location.href = `${props.capacity_error_url}?referrer=${encodeURIComponent(window.location.href)}`;
        return;
      }

      setChannelId(room.id)

      //ルームに参加
      const me = await room.join();
      
      // 自身のSkyWayIDを設定
      let room_me_id = me.id

      // 自分の映像・音声を送信
      await me.publish(audio);
      await me.publish(video);

      // 相手の映像・音声を受信
      const subscribeAndAttach = async (publication) => {
        // 自身はスキップ
        if (publication.publisher.id === me.id) return;
        const { stream } = await me.subscribe(publication.id);
        setIsSpeaking(true);
        let newMedia;
        switch (stream.track.kind) {
          case 'video':
            newMedia = document.createElement('video');
            newMedia.id = 'remote-video'
            // キャプチャ用
            const videoCanvas = document.createElement('canvas');
            videoCanvas.id = 'video-canvas'
            newMedia.playsInline = true;
            newMedia.autoplay = true;
            props.is_admin && captureImage.current.append(videoCanvas);
            break;
          case 'audio':
            newMedia = document.createElement('audio');
            newMedia.controls = true;
            newMedia.autoplay = true;
            break;
          default:
            return;
        }
        stream.attach(newMedia);
        remoteMediaArea.current.append(newMedia);
        
        startTimer();
        await setStartAt();
      };
      room.publications.forEach(subscribeAndAttach);
      
      // RoomにStreamがPublishされたときに発火
      room.onStreamPublished.add((e) => {
        subscribeAndAttach(e.publication);
      });

      const endCall = async () => {
        stopTimer();
        // メディアストリームを停止
        stopAllMediaStreams(audio, video, audioContext);
        await me.leave();
        await room.dispose();
        await context.dispose();
        setIsSpeaking(false);
        setIsEndCall(true);
      }

      // 通話終了押下時
      stopButton.current.onclick = async () =>{
        if (recordSessionIdRef.current !== "") {
          await recordEnd();
        }
        await endCall();
      }

      const roomClose = async () => {
        // メディアストリームを停止
        stopAllMediaStreams(audio, video, audioContext);
        // ルームを閉じる
        await room.close();
        // ルームインスタンス利用を終了
        await room.dispose();
        // SkywaySDKに関するすべての操作終了
        await context.dispose();
      }

      // Roomがメンバーが離脱したとき
      room.onMemberLeft.add(async(e)=>{
        
        // 自身の検知の場合はスキップ
        if (e.member.id === room_me_id) return;
        // 録音中の場合は録音を終了
        if (recordSessionIdRef.current !== "") {
          await recordEnd();
        }

        // 自身も退出
        await me.leave();
        // ルームの後処理
        await roomClose();
        stopTimer();
        setIsSpeaking(false);
        setIsEndCall(true);
        setEndAt();
      });

      reloadButton.current.onclick = async () => {
        // メディアストリームを停止
        stopAllMediaStreams(audio, video, audioContext);
        await me.leave();
        if(room.members.length === 0) {
          await room.close();
        }
        await room.dispose();
        await context.dispose();

        reloadPage();
      }

      // 例外処理
      context.onFatalError.add((error) => {
        stopTimer();
        setIsSpeaking(false);
        setIsEndCall(true);
      });
    }
    })();

  }, [])

  // Action Cable接続（channelIdが設定された後）
  useEffect(() => {
    if (!channelId) return;

    const consumer = createConsumer();
    const subscription = consumer.subscriptions.create(
      { channel: 'RoomChannel', channel_id: channelId },
      {
        received: (data) => {
          if (data.type === 'recording_start' || data.type === 'recording_end') {
            setRecordingNotification(data.message);
            setTimeout(() => setRecordingNotification(""), 5000);
          }
        }
      }
    );

    return () => {
      subscription?.unsubscribe();
    };
  }, [channelId]);

  useEffect(() => {
    let timer;
    if(recordSessionId !== "") {
      timer = setInterval(() => {
        setShowRecordButton((prev) => !prev);
      }, 500);
    }else{
      setShowRecordButton(true);
    }
    return () => clearInterval(timer);
  }, [recordSessionId])
  
  const startTimer = () => {
    let time_count = 0;
    timer = setInterval(() => {
      time_count++;
      setTime(time_count);
    }, 1000)
  }

  const stopTimer = () => {
    clearInterval(timer)
    setTime(0)
  }

  const setStartAt = () => {
    // 通話開始時刻登録
    axios.post(
      '/api/internal/rooms/set_start_at',{
        room_id: props.room_id
      }
    );
  }

  const setEndAt = () => {
    // 通話開始時刻登録
    axios.post(
      '/api/internal/rooms/set_end_at',{
        room_id: props.room_id
      }
    );
  }

  // キャプチャ取得
  const videoCapture = () => {
    setCaptureErrorMessage("");
    const video: HTMLVideoElement = document.getElementById('remote-video') as HTMLVideoElement;
    const canvas: HTMLCanvasElement = document.getElementById('video-canvas') as HTMLCanvasElement;
    const videoHeight: number = video.videoHeight;
    const videoWidth: number = video.videoWidth;

    canvas.height = videoHeight;
    canvas.width = videoWidth;
    canvas.getContext('2d').drawImage(video, 0, 0);

    const patient_image = canvas.toDataURL('image/png');

    const res = axios.post(
      '/api/internal/patients/register_patient_image',{
        headers: {
          'content-type': 'multipart/form-data',
        },
        patient_id: props.patient_id,
        patient_image: patient_image,
      }
    ).then(res => {
        setSuccessCaptureCount(successCaptureCount + 1);
        const element = document.createElement("img") as HTMLImageElement;
        element.src = patient_image;
        element.className = 'display-image';
        displayCaptureImages.current.appendChild(element);
        const modal = document.getElementById("capture_result");
        modal.click();
      }).catch(error =>{
        setCaptureErrorMessage(error.response.data.message);
        const modal = document.getElementById("capture_result");
        modal.click();
      });
  }

  function reloadPage(){
    location.reload(true);
  }

  // 初期状態チェック
  const videoCheck = () => {
    if (!props.test_render) {
      let messages = []
      const userAgent = window.navigator.userAgent.toLowerCase()
      const validBrowserRegex = /edge|chrome|safari|firefox/
  
      if (!userAgent.match(validBrowserRegex)) {
        messages.push("ビデオ通話の推奨ブラウザはEdge、Chrome、Safari、Firefoxです")
      }
  
      // カメラ、マイクのチェック
      navigator.mediaDevices.enumerateDevices().then(deviceInfos => {
        let deviseKinds = []
        deviceInfos.map((deviseInfo) => {
          deviseKinds.push(deviseInfo.kind)
        })
        if (!deviseKinds.includes("audioinput")) {
          messages.push("マイクを認識できません。問題がないか確認お願いします")
        }
        if (!deviseKinds.includes("videoinput")) {
          messages.push("カメラデバイスを認識できません。問題がないか確認お願いします")
        }
        const checkMedia = () => {
          navigator.mediaDevices.getUserMedia({
            video: true,
            audio: true
          }).then().catch((error) => {
            messages.push("マイクとカメラが許可されていません。ブラウザの設定からマイクとカメラを許可してください")
            if (messages.length != 0) {
              setVideoEnableCheckMessages(messages)
            }
          })
        }
        checkMedia()
        if (messages.length != 0) {
          setVideoEnableCheckMessages(messages)
        }
      })
    }
  }

  const recordStart = () => {
    setRecordSessionId("");
    setRecordingErrorMessage("");
    const res = axios.post(
      '/api/internal/rooms/recording_start',{
        channel_id: channelId,
        room_id: props.room_id,
      }
    ).then(res => {
      setRecordSessionId(res.data.session_id);
      recordSessionIdRef.current = res.data.session_id;
      startRecordingTimer();
    }).catch(error =>{
      setRecordingErrorMessage(error.response?.data?.error || "録音開始に失敗しました");
      const modal = document.getElementById("recording_error_trigger");
      modal?.click();
    });
  }

  const recordEnd = () => {
    stopRecordingTimer();
    const res = axios.post(
      '/api/internal/rooms/recording_end',{
        channel_id: channelId,
        room_id: props.room_id,
        session_id: recordSessionId
      }
    ).then(res => {
      setRecordSessionId("");
      recordSessionIdRef.current = "";
      setRecordingEnded(true);
    }).catch(error =>{
      
    });
  }

  // 録音タイマー開始
  const startRecordingTimer = () => {
    const timer = setInterval(() => {
      setRecordingTime(prev => {
        const newTime = prev + 1;
        if (newTime >= RECORDING_MAX_TIME) {
          // 15分経過で自動終了
          recordEnd();
          return 0;
        }
        return newTime;
      });
    }, 1000);
    setRecordingTimer(timer as unknown as NodeJS.Timeout);
  };

  // 録音タイマー終了
  const stopRecordingTimer = () => {
    if (recordingTimer) {
      clearInterval(recordingTimer);
    }
    setRecordingTimer(null);
    setRecordingTime(0);
  };

  // 残り時間表示
  const formatTime = (seconds: number) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}分${secs.toString().padStart(2, '0')}秒`;
  };

const remainingTime = RECORDING_MAX_TIME - recordingTime;

  return (
    <>
      {
        isEndCall ? (
          <>
            <div className="height-90">
              <div className="col-md-12 col-sm-12 col-xs-12">
                <h4 className="text-center">ビデオ通話が終了されました。</h4>
                <h4 className="text-center">再度、ビデオ通話を開始する場合は</h4>
                <h4 className="text-center"><a onClick={reloadPage} className="text-primary page-reload-font">こちら</a>を押してください。</h4>
                <h4 className="text-center">このまま終了する場合はこのページを閉じてください。</h4>
              </div>  
              <br/>
              <div className="text-center col-md-12 col-sm-12 col-xs-12">
                <img src={thankyouImg} className="human-img" alt="アイコン"></img>
              </div>
            </div>
          </>
        ):(
        <div className="video-full-content">
          {/* 注意文など */}
          <div className="video-header col-lg-12 col-md-12 col-sm-12 col-xs-12">
            {/* 録音通知 */}
            {recordingNotification && (
              <div className="alert alert-info recording-notification">
                {recordingNotification}
              </div>
            )}
            {
              videoEnableCheckMessages.length != 0 ? (
                <div className="video-check-alert well well-sm col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  { videoEnableCheckMessages.map((message) => { return (<>{message}</>) })}
                </div>
              ):(
                <div className="video-note well well-sm col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  自身の映像が表示されない場合は、カメラ設定をご確認頂くか「<a ref={reloadButton} className="text-primary page-reload-font">ページ更新</a>」を押してください。<br/>
                  ※ブラウザの更新ボタンは利用しないでください
                </div>
              )
            }
            {/* 店舗名／通話時間／キャプチャ成功数／ヘルプボタン */}
            <div className="col-lg-9 col-md-9 col-sm-9 col-xs-9 text-left pl0">
                <div className="well well-sm institution_name bg-transparent">
                  {props.is_admin ? props.patient_name + " 様" : props.institution_name}
                </div>
              { isSpeaking && <> <br/> <div className="well well-sm video-time bg-transparent">通話時間: {Math.floor(time / 60)}分{time % 60}秒</div></>}
              { (props.is_admin && isSpeaking && successCaptureCount > 0) && 
                <> 
                  <br/> 
                  <div className="well well-sm video-time bg-transparent">
                    キャプチャ成功数: <a data-toggle="modal" data-target="#modalCapture" className="text-primary page-reload-font">{successCaptureCount}</a>枚
                  </div>
                </>
              }
              { (recordSessionId !== "" && props.is_admin) && 
                <> 
                  <br/> 
                  <div className="well well-sm video-time bg-transparent">
                    録音残り時間: {formatTime(remainingTime)}
                  </div>
                </>
              }
            </div>
            {
              (props.is_display_reserve_note || props.institution_phone_number) &&
              <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3 text-right">
                <button className="btn button-circle information-btn" data-toggle="modal" data-target="#myModal">
                  <img className="information-img" src={informationImg} />
                </button>
              </div>
            }
          </div>
  
          <div className="row">
            <div className="button-area padding-bottom-10 col-lg-6 col-md-6 col-sm-6 col-xs-6 pl0">
              {/* 通話終了ボタン */}
              <button id="js-leave-trigger" className="btn stop-video-btn button-circle" data-toggle="modal" data-target="#closeCall">
                <img className="stop-video-img" src={endCallImg} />
              </button>
              { (props.is_admin && isSpeaking) &&
                <>
                  {/* キャプチャボタン */}
                  <div ref={captureImage} id="video-canvus" hidden />
                  <button onClick={videoCapture} id="js-leave-trigger" className="btn camera-btn button-circle">
                    <img className="camera-img" src={cameraImg} />
                  </button>
                  <input id="capture_result" type="hidden" data-toggle="modal" data-target="#modalCaptureResult"/>
                  {/* 録音ボタン */}
                  {
                    props.can_record && !recordingEnded && (
                    <>
                      <input id="recording_error_trigger" type="hidden" data-toggle="modal" data-target="#modalRecordingError"/>
                      <button className="btn camera-btn button-circle"  data-toggle="modal" data-target="#modalRecordingStart">
                        {showRecordButton && <img className="recording-img" src={recordCircleImg} />}
                      </button>
                    </>
                    )
                  }

                </>
                
              }
            </div>
            {/* マイクエリア */}
            <div className="local-mic col-lg-2 col-md-2 col-sm-3 col-xs-5 bg-transparent">
              <div>
                <div className="mic-area pl5 pr0 col-lg-2 col-md-2 col-sm-2 col-xs-2 ">
                  <img className="mic-img" src={micIcon} />
                </div>
                <div className="mic-area pl0 pr5 col-lg-9 col-md-9 col-sm-9 col-xs-9">
                  <canvas id="canvas" className="canvas-audio"></canvas>
                </div>
              </div>
            </div>
            {/* 自分の映像 */}
            <div className="local-stream col-lg-6 col-md-6 col-sm-6 col-xs-6">
              <video id="js-local-stream" className="h150" muted playsInline ref={localVideo}></video>
            </div>
          </div>
          {/* 相手の映像 */}
          {isSpeaking ?
            (
              <div className="remote-video" id="js-remote-streams" ref={remoteMediaArea}></div>
            ):(
              <div className="remote-video bg-color-black text_color_white text-message">
                <div className  ="text-center">
                  <h3>
                    {props.is_admin ? props.patient_name + " 様 未入室" : props.is_clinic ? "担当医師 未入室" : "薬剤師 未入室"}
                    <br/><br/>
                    { props.scheduled_date} <br/>
                    {props.scheduled_start_at + "-" + props.scheduled_end_at}<br/>
                    <br/>
                  </h3>
                  <p>{props.is_admin ? props.patient_name + " 様が入室するまでお待ちください。" : props.is_clinic ? "担当医師が入室するまでお待ちください。" : "薬剤師が入室するまでお待ちください。"}</p>
                </div>
              </div>
            )
          }
        </div> 
        )
      }

      {/* 注意事項モーダル */}
      <div id="myModal" className="modal fade" role="dialog">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <button type="button" className="close" data-dismiss="modal">&times;</button>
              <h4 className="modal-title">インフォメーション</h4>
            </div>
            <div className="modal-body">
              { props.institution_phone_number &&
              <div className="panel panel-default">
                <div className="panel-heading">問い合わせ電話番号</div>
                <div className="panel-body">
                  {props.institution_phone_number}
                </div>
              </div>
              }
              { props.is_display_reserve_note &&
                <div className="panel-group">
                  <div className="panel panel-default">
                    <div className="panel-heading">注意事項・ご用意頂くもの</div>
                    <div className="panel-body">
                      <textarea disabled={true} className="form-control" rows={15} placeholder="注意事項・ご用意頂くものを入力して下さい" name="m_institution[reserve_note]" id="m_institution_reserve_note">
                        {props.reserve_note}
                      </textarea>
                    </div>
                  </div>
                </div>
              }

            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-default" data-dismiss="modal">閉じる</button>
            </div>
          </div>
       </div>
      </div>

      {/* キャプチャモーダル */}
      <div id="modalCapture" className="modal fade" role="dialog">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <button type="button" className="close" data-dismiss="modal">&times;</button>
              <h4 className="modal-title">キャプチャリスト</h4>
            </div>
            <div className="modal-body">
              <div id="captured-images" ref={displayCaptureImages}></div>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-default" data-dismiss="modal">閉じる</button>
            </div>
          </div>
       </div>
      </div>

      {/* キャプチャ成功／失敗モーダル */}
      <div id="modalCaptureResult" className="modal fade" data-backdrop="static">
        <div className="sw-modal-content">
          <div className="sw-modal-dialog" style={{ minHeight: '363px'}}>
            {
              captureErrorMessage === "" ? (
                <>
                  <div className="swal2-icon swal2-success animate-success-icon" style={{display: "block"}}>
                    <span className="line tip"/> <span className="line long"/><div className="placeholder"/><div className="fix"/>
                  </div>
                  <h2>キャプチャ取得成功</h2>
                  <div className="sw-modal-body" style={{ marginBottom: '50px'}}>
                    キャプチャの保存に成功しました。<br/>
                  </div>
                </>
              ):(
                <>
                  <div className="swal2-icon swal2-error animate-error-icon" style={{display: "block"}}>
                    <span className="x-mark animate-x-mark">
                      <span className="line left"/><span className="line right"/>
                    </span>
                  </div>
                  <h2>キャプチャ取得失敗</h2>
                  <div className="sw-modal-body" style={{ marginBottom: '50px'}}>
                    {captureErrorMessage}<br/>
                  </div>
                </>
              )
            }
            <button type="button" className="sw-modal-btn" data-dismiss="modal">閉じる</button>
          </div>
        </div>
      </div>

      {/* 通話終了モーダル */}
      <div id="closeCall" className="modal fade" role="dialog">
        <div className="sw-modal-content">
        <div className="sw-modal-dialog" style={{ minHeight: '363px'}}>
            <div className="sw-modal-icon-question sw-modal-icon">?</div>
            <h2>ビデオ通話を終了しますか？</h2>
            <div className="sw-modal-body" style={{ marginBottom: '50px'}}>
            </div>
            <a type="button"
                className="sw-modal-btn"
                style={{ backgroundColor: 'red', textDecoration: 'none'}}
                data-dismiss="modal"
                ref={stopButton}
            >
              はい
            </a>
            <button type="button" className="sw-modal-btn" data-dismiss="modal">いいえ</button>
        </div>
        </div>
      </div>

      {/* 録音開始／終了モーダル */}
      <div id="modalRecordingStart" className="modal fade" role="dialog">
        <div className="sw-modal-content">
        <div className="sw-modal-dialog" style={{ minHeight: '363px'}}>
            <div className="sw-modal-icon-question sw-modal-icon">?</div>
            {
              recordSessionId == "" ? (
                <>
                  <h2>録音を開始します</h2>
                  <br/>
                  <h3>最大録音時間は15分です。</h3>
                  <br/>
                  <h3>15分経過すると自動で録音が終了します</h3>
                </>
              ):(
                <>
                  <h2>録音を終了します</h2>
                  <br/>
                  <h3 className="red bold">１予約につき録音は１回のみです。</h3>
                  <br/>
                  <h3 className="red bold">録音を終了すると、再度録音することはできません。</h3>
                  <br/>
                  <h3>録音を終了します。よろしいですか？</h3>
                </>
              )
            }
            
            <div className="sw-modal-body" style={{ marginBottom: '50px'}}>
            </div>
            <a type="button"
                className="sw-modal-btn"
                style={{ backgroundColor: 'red', textDecoration: 'none'}}
                data-dismiss="modal"
                onClick={recordSessionId == "" ? recordStart : recordEnd}
            >
              はい
            </a>
            <button type="button" className="sw-modal-btn" data-dismiss="modal">いいえ</button>
        </div>
        </div>
      </div>

      {/* 録音エラーモーダル */}
      <div id="modalRecordingError" className="modal fade" data-backdrop="static">
        <div className="sw-modal-content">
          <div className="sw-modal-dialog" style={{ minHeight: '363px'}}>
            <div className="swal2-icon swal2-error animate-error-icon" style={{display: "block"}}>
              <span className="x-mark animate-x-mark">
                <span className="line left"/><span className="line right"/>
              </span>
            </div>
            <h2>録音開始エラー</h2>
            <div className="sw-modal-body" style={{ marginBottom: '50px'}}>
              {recordingErrorMessage}<br/>
            </div>
            <button type="button" className="sw-modal-btn" data-dismiss="modal">閉じる</button>
          </div>
        </div>
      </div>
    </>
  )
}
export default newCall
